import { isNil } from 'lodash';
import React from 'react';
import IndexTableBodyCell from '../../../../shared/index/table/body_cell';

export const AverageScoreCell = ({ averageScore }) => (
  <IndexTableBodyCell size="s" name="average-score" hideBelowMD center>
    {averageScore ? `${parseInt(averageScore, 10)}%` : '-'}
  </IndexTableBodyCell>
);

export const CompletedCountCell = props => (
  <IndexTableBodyCell size="s" name="completed-count" hideBelowMD center>
    {props.completedCount}
  </IndexTableBodyCell>
);

export const LastCompletedCell = ({ lastCompleted }) => {
  const date = lastCompleted ? moment(lastCompleted) : null;
  return (
    <IndexTableBodyCell
      size="s"
      name="last-completed"
      title={date ? date.format('MMMM DD, YYYY') : null}
      hideBelowMD
      center
    >
      {date ? date.fromNow() : '-'}
    </IndexTableBodyCell>
  );
};

export const LastActivityCell = ({ lastActivity }) => {
  const date = lastActivity ? moment(lastActivity) : null;

  return (
    <IndexTableBodyCell
      size="m"
      name="last-activity"
      title={date ? date.format('MMMM DD, YYYY') : null}
      hideBelowMD
      center
    >
      {date ? date.fromNow() : '-'}
    </IndexTableBodyCell>
  );
};

export const FreshnessScoreCell = ({ freshnessScore }) => (
  <IndexTableBodyCell size="s" name="freshness-score" hideBelowMD center>
    {isNil(freshnessScore) ? '-' : freshnessScore}
  </IndexTableBodyCell>
);
